import React from 'react';
import ChatList from './ChatList';

const ChatSidebar = ({ conversations, loading, selectConversation,selectedConversation }: any) => {
  return (
    <div className="w-1/3 min-w-[460px] overflow-y-auto bg-[#FDF6F9] h-fit grid grid-cols-1 gap-4 p-4 rounded-md">
      <ChatList selectedConversation={selectedConversation} conversations={conversations} loading={loading} selectConversation={selectConversation} />
    </div>
  );
};

export default ChatSidebar;
